<template>
  <div class="app-top">
    <div class="top-left" :style="!showUserPanel?'margin-left:240px':''">
      <el-menu mode="horizontal" :background-color="variables.topbarBg" text-color="#BFCBD9" active-text-color="#BFCBD9" @select="leftSelect">
        <el-menu-item index="collapse"><i class="el-icon-s-fold"></i></el-menu-item>
        <el-menu-item index="refresh"><i class="el-icon-refresh" @click="refresh"></i></el-menu-item>
        <el-menu-item index="fullScreen" v-if="isFullScreen && $store.state.app.device !== 'mobile'"><i class="el-icon-full-screen" title="全屏"></i></el-menu-item>
      </el-menu>
    </div>
    <div class="top-right" v-show="showUserPanel">
      <el-menu mode="horizontal" :background-color="variables.transparent" router>
        <el-submenu index="2" popper-class="popperClass">
          <template slot="title"><img class="avatar" :src="require('@/assets/avatar1.png')" /> <span>{{ name }}</span></template>
          <el-menu-item index="/person/info">我的资料</el-menu-item>
          <el-menu-item @click="modifyPwd">修改密码</el-menu-item>
        </el-submenu>
        <el-menu-item index="4" style="padding-right: 10px" @click="exit"><i class="el-icon-switch-button"></i><span>安全退出</span></el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
import variables from "@/styles/variables.scss"
import screenfull from "screenfull"
export default {
  name: "Topbar",
  inject: ['reload'],
  components: {},
  data() {
    return {
      isFullScreen: true,
      name: "",
    }
  },
  computed: {
    variables() {
      return variables
    },

    showUserPanel(){
      if(this.$store.state.app.device=='mobile'){
        if(this.$store.state.app.sidebar.opened){
          return false;
        }
      }
      return true;
    }
  },
  created() {
    this.isFullScreen = !screenfull.enabled
  },
  mounted() {
    this.name = this.$store.state.user.name
  },

  watch: {
    "$store.state.user.name"() {
      this.name = this.$store.state.user.name
    },
  },
  methods: {
    //因此或者折叠左侧菜单
    leftSelect(index) {
      if (index == "collapse") {
        this.$store.dispatch("app/toggleSideBar", { withoutAnimation: false })
      } else if (index == "fullScreen") {
        screenfull.toggle()
      }
    },

    //刷新页面
    refresh(){
      this.reload();
    },

    modifyPwd(){
      this.$router.push('/forgetPwd');
    },

    exit() {
      this.$confirm("确定退系统？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        this.$store.commit("user/SET_TOKEN", "")
        this.$router.push("/login")
      })
    },
  },
}
</script>


<style scoped>
.app-top /deep/ .el-dropdown {
  color: #fff;
  line-height: 50px;
}

.app-top /deep/.el-menu{
  background-color: transparent;
}

.app-top /deep/.el-menu--horizontal > .el-submenu .el-submenu__title {
  height: 60px;
  line-height: 60px;
  border-bottom: none;
  color: #BFCBD9;
}
.app-top /deep/.el-menu--horizontal > .el-submenu.is-opened,
.app-top /deep/.el-menu--horizontal > .el-submenu .el-submenu__title:hover,
.app-top /deep/.el-menu--horizontal > .el-submenu .el-submenu__title:focus {
  background-color: #4a81e8;
}

.app-top /deep/ .el-menu--horizontal > .el-menu-item {
  height: 60px;
  line-height: 60px;
  border-bottom: none;
  color: #BFCBD9;
}

.app-top /deep/ .el-menu--horizontal > .el-menu-item:hover{
  background-color: #4a81e8;
  color: #BFCBD9;
}
.app-top /deep/ .el-menu--horizontal > .el-menu-item:focus{
  background-color: transparent;
  color: #BFCBD9;
}

.app-top /deep/ .el-submenu__title i {
  color: #bfcbd9;
}

.app-top /deep/ .el-menu-item i {
  color: #bfcbd9;
  margin: 0;
}

.app-top /deep/ .el-menu--popup-bottom-start {
  margin-top: 0;
}

.app-top .avatar {
  width: 40px;
  height: 40px;
  margin-right: 10px;
}

.popperClass{
  background: #FFF;
}
</style>
